export default "__VITE_ASSET__60b590f1__"